var _ = require('underscore');
var Section = require('front/pages/Section/Section');

require('./AwardsADG.less');

var AwardsADGContent = require('front/components/AwardsADGContent/AwardsADGContent');

module.exports = Section.extend({

    el: '.AwardsADG',

    events: {
    },


    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'AwardsADGContent': {selector: '.AwardsADGContent', viewConstructor: AwardsADGContent}
    },


    initialize: function (options) {
        this.options = options || {};

        Section.prototype.initialize.call(this, options);
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/AwardsADG/AwardsADG.js
// module id = 247
// module chunks = 0